import { render, staticRenderFns } from "./trans_other.vue?vue&type=template&id=3abc6216&scoped=true"
import script from "./trans_other.vue?vue&type=script&lang=js"
export * from "./trans_other.vue?vue&type=script&lang=js"
import style0 from "./trans_other.vue?vue&type=style&index=0&id=3abc6216&prod&scoped=scoped&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3abc6216",
  null
  
)

export default component.exports